_ = {
  btnJumpToSection: ".js-btn-jump-to-section",
  qty_buttons: ".js-qty-btn",
  qty_wrapper: ".js-subscription-qty-wrpper",
  atc_wrapper: ".js-atc-wrapper",
  product_card: ".js-product-card",
  addToCardButton: ".js-atc-btn-actions",
  qtyInput: "input[data-quantity-input]",
  firstStepButton: ".js-first-step-btn",
  secondStepButton: ".js-second-step-btn",
  frequencyButton: ".js-frequency-btn",
  frequencyWrapper: ".js-subscription-frequency--wrapper",
  oneTimeAddOnsWrapper: ".js-one-time-add-ons-section--wrapper",
  subscriptionWrapper: ".js-subscription-products--wrapper",
  mainAddToCartButton: ".js-finala-add-to-cart-btn",
  stepButton: ".js-step-button",
};

__ = {
  btnJumpToSection: document.querySelector(_.btnJumpToSection),
  qty_buttons: document.querySelectorAll(_.qty_buttons),
  addToCardButton: document.querySelectorAll(_.addToCardButton),
  firstStepButton: document.querySelector(_.firstStepButton),
  secondStepButton: document.querySelector(_.secondStepButton),
  frequencyButton: document.querySelectorAll(_.frequencyButton),
  frequencyWrapper: document.querySelector(_.frequencyWrapper),
  oneTimeAddOnsWrapper: document.querySelector(_.oneTimeAddOnsWrapper),
  mainAddToCartButton: document.querySelector(_.mainAddToCartButton),
  stepButton: document.querySelectorAll(_.stepButton),
};

window.Subscription = {
  init: function () {
    this._initQtyListener();
    this._initAddToCartListener();
    this._clickToScrollAction();
    this._frequencySelection();
    this._stepButtonListener();
    this._subscriptionAddToCartListener();
  },

  _scrollSection: function (targetSection) {
    let headerNav = document.querySelector(
        "[data-header-section] header .site-header__mobile-nav"
      ),
      announcmentBar = document.querySelector(
        "[data-header-section] .announcement-bar"
      );
    let sectionOffsetTop =
      targetSection.offsetTop -
      ((headerNav ? headerNav.offsetHeight : 0) +
        (announcmentBar ? announcmentBar.offsetHeight : 0));
    window.scrollTo({
      top: sectionOffsetTop,
      behavior: "smooth",
    });
  },

  _stepButtonListener: function () {
    __.stepButton.forEach((element) => {
      element.addEventListener("click", function () {
        document
          .querySelector(`${this.dataset.jsTarget}`)
          .classList.remove("hide");
        window.Subscription._scrollSection(
          document.querySelector(`${this.dataset.jsTarget}`).offsetParent
        );
      });
    });
  },

  _clickToScrollAction: function () {
    __.btnJumpToSection.addEventListener("click", function (e) {
      let targetSection = document.querySelector(this.getAttribute("href"));
      if (targetSection) {
        e.preventDefault();
        window.Subscription._scrollSection(targetSection);
      }
    });
  },

  _getSelectedProducts() {
    let subscriptionItems = document.querySelectorAll(
        `${_.subscriptionWrapper} ${_.product_card}.item-selected`
      ),
      normalProductItems = document.querySelectorAll(
        `${_.oneTimeAddOnsWrapper} ${_.product_card}.item-selected`
      ),
      subscriptionItemsArray = [],
      normalProductsArray = [],
      autoAddOnItem = null;

    subscriptionItems.forEach((element) => {
      var subInfo = element.querySelector(_.qtyInput).dataset.subInfo;

      let tmpArray = {};
      tmpArray["id"] = element.querySelector(_.qtyInput).dataset.variantId;
      //tmpArray['id'] = element.querySelector(_.qtyInput).dataset.subId;
      tmpArray["quantity"] = element.querySelector(_.qtyInput).value;
      tmpArray["properties"] = { _subscribe: true };

      //SKIO UPDATE: calculate appropriate selling_plan ID value for the selected selling plan frequenct
      let variantId = element.querySelector(_.qtyInput).dataset.variantId;
      let sellingPlanGroups = JSON.parse(
        element.querySelector(_.qtyInput).dataset.sellingPlanGroups
      );

      const variants = JSON.parse(
        element.querySelector(_.qtyInput).dataset.variants
      );

      const currentVariant = variants.find(
        (v) => v.id.toString() === variantId.toString()
      );

      const variantSellingPlans = sellingPlanGroups
        .filter((spg) => spg.app_id === "SKIO")
        .map((spg) => spg.selling_plans)
        .flat()
        .filter((sp) =>
          currentVariant.selling_plan_allocations.some(
            (spa) => spa.selling_plan_id === sp.id
          )
        );

      let selected_frequency = `Every ${
        __.frequencyWrapper.querySelector(`${_.frequencyButton}.selected`)
          .dataset.frequency
      } months`;

      const sellingPlan = variantSellingPlans.find(
        (sp) => sp.name === selected_frequency
      );

      if (variantSellingPlans.length && sellingPlan) {
        tmpArray["selling_plan"] = sellingPlan.id;
        tmpArray["properties"]["Discount"] = "15% off";
        subscriptionItemsArray.push(tmpArray);
      } else {
        console.log(
          "Error getting selling plan groups data: ",
          element.querySelector(_.qtyInput).dataset
        );
        subscriptionItemsArray.push(tmpArray);
      }
    });

    normalProductItems.forEach((element) => {
      let tmpArray = {};
      tmpArray["id"] = element.querySelector(_.qtyInput).dataset.variantId;
      tmpArray["quantity"] = element.querySelector(_.qtyInput).value;
      normalProductsArray.push(tmpArray);
    });

    const addOnId = document
      .querySelector("[data-free-product]")
      .getAttribute("data-free-product");

    const chaiMixIds = [
      43667238813920, 43667259162848, 43667268993248, 43624835023072,
    ];
    const chaiMixSelected = subscriptionItemsArray.some((item) =>
      chaiMixIds.includes(parseInt(item.id))
    );

    if (chaiMixSelected) {
      autoAddOnItem = {
        id: addOnId,
        quantity: 1,
      };
    }

    return {
      subscriptionProducts: {
        count: subscriptionItems.length,
        products: subscriptionItemsArray,
      },
      normalProductItems: {
        count: normalProductsArray.length,
        products: normalProductsArray,
      },
      autoAddOnItem,
    };
  },

  _initQtyListener() {
    __.qty_buttons.forEach((element) => {
      element.addEventListener("click", function () {
        let qtyInput = this.closest(_.qty_wrapper).querySelector(_.qtyInput);
        var calc = this.classList.contains("js-btn-plus")
          ? parseInt(qtyInput.value) + 1
          : parseInt(qtyInput.value) - 1;
        calc > 0
          ? this.closest(_.product_card).classList.add("item-selected")
          : this.closest(_.product_card).classList.remove("item-selected");
        const maxQty = parseInt(qtyInput.getAttribute("data-max-quantity"));
        if (maxQty) {
          qtyInput.value = Math.max(1, maxQty);
        } else {
          qtyInput.value = Math.max(1, calc);
        }
        window.Subscription._showHideStepButtons();
      });
    });
  },

  _initAddToCartListener() {
    __.addToCardButton.forEach((element) => {
      element.addEventListener("click", function () {
        this.closest(_.product_card).classList.add("item-selected");
        window.Subscription._showHideStepButtons();
      });
    });
  },

  _showHideStepButtons() {
    if (this._getSelectedProducts().subscriptionProducts.count > 0) {
      __.firstStepButton.classList.remove("disabled");
      __.firstStepButton.removeAttribute("disabled");
    } else {
      __.firstStepButton.classList.add("disabled");
      __.firstStepButton.setAttribute("disabled", true);
      __.frequencyWrapper.classList.add("hide");
      __.oneTimeAddOnsWrapper.classList.add("hide");
    }

    if (__.frequencyWrapper.querySelector(`${_.frequencyButton}.selected`)) {
      __.secondStepButton.classList.remove("disabled");
      __.secondStepButton.removeAttribute("disabled");
    } else {
      __.secondStepButton.classList.add("disabled");
      __.secondStepButton.setAttribute("disabled", true);
    }
  },

  _frequencySelection: function () {
    __.frequencyButton.forEach((element) => {
      element.addEventListener("click", function () {
        if (
          __.frequencyWrapper.querySelector(`${_.frequencyButton}.selected`)
        ) {
          __.frequencyWrapper
            .querySelector(`${_.frequencyButton}.selected`)
            .classList.remove("selected");
        }
        this.classList.add("selected");
        window.Subscription._showHideStepButtons();
      });
    });
  },

  _subscriptionAddToCartListener: function () {
    __.mainAddToCartButton.addEventListener("click", function () {
      let selectedProducts = window.Subscription._getSelectedProducts(),
        subscriptionProducts = selectedProducts.subscriptionProducts.products,
        normalProducts = selectedProducts.normalProductItems.products,
        autoAddOnProduct = selectedProducts.autoAddOnItem,
        finalItems = [...normalProducts, ...subscriptionProducts];

      if (autoAddOnProduct) {
        finalItems.push(autoAddOnProduct);
      }

      fetch(window.Shopify.routes.root + "cart.js", {})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          data.items.forEach((element) => {
            if (element.variant_id == autoAddOnProduct.id) {
              isBonusProductInCart = true;
            }
          });

          let formData = {
            items: finalItems,
          };

          //console.log("skio test final items: ", finalItems);

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              console.log("hitting this?");
              window.slideCart.getCart();
              window.slideCart.cartToggle();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        });
    });
  },
};

Subscription.init();

$(document).ready(function () {
  $(".page-container").addClass("page-subscription");

  $("a.smooth_scroll_to").click(function () {
    const target = $(this).data("target");
    window.scrollTo({
      top: $(target).offset().top,
      behavior: "smooth",
    });
  });

  $(".diy_item_slider").slick({
    dots: true,
    appendArrows: $(".diy_slider_nav"),
    prevArrow: $(".diy_slider_arrow_prev"),
    nextArrow: $(".diy_slider_arrow_next"),
    appendDots: $(".diy_slider_dots"),
  });

  $(".carousel_announcement_bar .callout_slider_wrapper").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    autoplaySpeed: 5000,
    autoplay: true,
  });

  $(
    "#shopify-section-subscription_collection .product_card_stars button.product_card_info_toggle"
  ).each(function () {
    $(this).on("click", function () {
      $(this).closest(".product-card").toggleClass("info-active");
    });
  });

  $(".js-collection-slider .grid__item--subscription_collection").each(
    function () {
      var varID = $(this).find("[data-quantity-input]").attr("data-variant-id");
      var subInfo = $(this)
        .find("[data-quantity-input]")
        .attr("data-sub-info")
        .replaceAll("=>", ":");
      var subInfoJson = JSON.parse(subInfo);
      $(this)
        .find("[data-quantity-input]")
        .attr("data-sub-id", subInfoJson[varID].discount_variant_id);

      var disPrice = subInfoJson[varID].discount_variant_price;
      disPrice = theme.Currency.formatMoney(disPrice, theme.moneyFormat);
      var regPrice = $(this)
        .find(".price--listing .price__sale .price-item--sale")
        .text();
      var priceHTML = "";
      priceHTML += '<div class="price__sale">';
      priceHTML += "<dt>";
      priceHTML +=
        '<span class="visually-hidden visually-hidden--inline">Sale price</span>';
      priceHTML += "</dt>";
      priceHTML += "<dd>";
      priceHTML +=
        '<span class="price-item price-item--sale">' + disPrice + "</span>";
      priceHTML += "</dd>";
      priceHTML += '<div class="price__compare">';
      priceHTML += "<dt>";
      priceHTML +=
        '<span class="visually-hidden visually-hidden--inline">Regular price</span>';
      priceHTML += "</dt>";
      priceHTML += "<dd>";
      priceHTML +=
        '<s class="price-item price-item--regular">' + regPrice + "</s></dd>";
      priceHTML += "</div>";
      priceHTML += "</div>";
      $(this)
        .find(".price-item--sale")
        .parents("dl.price--listing")
        .html(priceHTML)
        .addClass("price--on-sale");
    }
  );

  // subscription_hero.liquid
  const hero = document.querySelector("#subscription_hero");

  if (hero) {
    const $heroBadges = $("#shopify-section-subscription_hero .badges");
    const badgesTopEnd = $heroBadges.offset().top + 88;

    $(window).scroll(function () {
      const scrollTopTarget = 200;
      const distanceInDecimal = $(this).scrollTop() / scrollTopTarget; // 0 -> 1 value

      const badges = [
        {
          start: {
            left: 113,
            top: 225,
          },
          end: {
            left: window.innerWidth / 2 - 304,
            top: badgesTopEnd,
          },
        },
        {
          start: {
            left: 223,
            top: -55,
          },
          end: {
            left: window.innerWidth / 2,
            top: badgesTopEnd,
          },
        },
        {
          start: {
            right: 22,
            top: 22,
          },
          end: {
            right: window.innerWidth / 2 - 304,
            top: badgesTopEnd,
          },
        },
      ];

      if ($(this).scrollTop() < scrollTopTarget) {
        badges.forEach((badge, index) => {
          const $badgeEl = $(`.badge_${index + 1}`);

          if (index === 2) {
            $badgeEl.css(
              "right",
              badge.start.right +
                (badge.end.right - badge.start.right) * distanceInDecimal +
                "px"
            );
          } else if (index === 1) {
            $badgeEl.css(
              "left",
              badge.start.left +
                (badge.end.left - badge.start.left) * distanceInDecimal +
                "px"
            );
          } else {
            $badgeEl.css(
              "left",
              badge.start.left +
                (badge.end.left - badge.start.left) * distanceInDecimal +
                "px"
            );
          }

          $badgeEl.css(
            "top",
            badge.start.top +
              (badge.end.top - badge.start.top) * distanceInDecimal +
              "px"
          );
        });
      } else {
        badges.forEach((badge, index) => {
          const $badgeEl = $(`.badge_${index + 1}`);

          $badgeEl.css("top", badge.end.top + "px");

          switch (index) {
            case 2:
              $badgeEl.css("right", badge.end.right + "px");
              break;
            default:
              $badgeEl.css("left", badge.end.left + "px");
          }
        });
      }

      // scrollTop 0 -> 350px
      // ===> need to calculate 0->1 value

      // USP #1
      // left: 113px -> calc(50vw - 204px), if 1440px screen then 720 - 204px, therefore 113px -> 516px
      // (403) (at .5 scroll, left should be at start + 201.5, which is 314.5)
      // top: 225px -> 514px (289) (at .5 scroll, top should be at start + 144.5, which is 369.5)
    });
  }
});
